import { InputBaseReactComponent } from '../input-base-react/input-base-react.component';
import { Component, forwardRef, Input, OnChanges, OnInit } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR, Validators } from '@angular/forms';

@Component({
  selector: 'app-input-datetime-alt-react',
  templateUrl: './input-datetime-alt-react.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputDateTimeAltReactComponent),
      multi: true
    }
  ]
})

export class InputDateTimeAltReactComponent extends InputBaseReactComponent implements ControlValueAccessor, OnInit, OnChanges {

  @Input() tipo:'date' | 'datetime' | 'time' | 'datetime-local' = 'date';

  constructor() {
    super();
  }

  // chama método ngOnInit da classe base e prepara valores de spans de validação
  ngOnInit(): void {

    super.ngOnInit();

    this.setAndUpdateValidators();
  }

  // chama método ngOnChanges da classe base e efetua o recarregamento de validadores.
  ngOnChanges(): void {
    super.ngOnChanges();
    this.setAndUpdateValidators();
  }

  isValidInput(): boolean {
    if (!this.value) {
      return false;
    }
    if (this.detailMode || this.readOnly || !this.required) {
      return true
    }

    switch (this.tipo) {
      case 'date':
        return !isNaN(Date.parse(this.value));
      case 'datetime':
      case 'datetime-local':
        return !isNaN(Date.parse(this.value));
      case 'time':
        return /^([0-1]?[0-9]|2[0-3]):[0-5][0-9](:[0-5][0-9])?$/.test(this.value);
      default:
        return false;
    }
  }
}
